import { useContext } from 'react';

import GetCharityQuery from './GetCharityQuery';
import StateContext from './StateContext';
import useQuery from '../../api/useQuery';

const usePreselectedCharity = () => {
  const {
    setCharity, rememberCharity, setPreselectedCharityId, session: { preselectedCharityId },
  } = useContext(StateContext);

  const { data } = useQuery(GetCharityQuery, {
    variables: {
      id: preselectedCharityId,
    },
    skip: !preselectedCharityId,
    onCompleted: ({ charity }) => {
      setCharity(charity);
      rememberCharity(charity);
    },
    onError: () => {
      setCharity(null);
      setPreselectedCharityId(null);
    },
  });

  return {
    preselectedCharity: data?.charity,
    hasPreselectedCharity: !!preselectedCharityId,
  };
};

export default usePreselectedCharity;
